<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="TNIS"><span class="ePub-I">I dedicate this book to my granddaughters, Aanya and Mira, who are the wellspring of happiness and joy in my life and inspire me to live in harmony and with abundance.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?660df45a